import React from 'react'
import { Modal } from '@enamelai/design-system'

type ChartingEditChartModalProps = {
  show: boolean
  chartName: string
  actionVerb?: 'update' | 'edit'
  onCancel: () => void
  onContinue: () => void
}

const ChartingEditChartModal: React.FC<ChartingEditChartModalProps> = ({
  show,
  chartName,
  actionVerb = 'edit',
  onCancel,
  onContinue,
}) => {
  const name = chartName.trim() || 'this chart'
  const description =
    actionVerb === 'update'
      ? `You are about to make changes to ${name}. Do you want to proceed?`
      : `You are about to edit ${name}. Do you want to proceed?`

  return (
    <Modal
      open={show}
      onClose={onCancel}
      size="xs"
      title="Edit chart"
      description={description}
      primaryLabel="Continue"
      secondaryLabel="Cancel"
      onPrimaryClick={onContinue}
      onSecondaryClick={onCancel}
    />
  )
}

export default ChartingEditChartModal
